import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import './errorMonitor.css';

const successCodes = [200, 201, 204];
const errorCodes = [400, 401, 403, 404, 500, 502, 503, 504];

export const ErrorMonitor = () => {
  const navigate = useNavigate();

  const triggerHandled = useCallback(async (code) => {
    try {
      await axios.get(`https://mock.httpstatus.io/${code}`);
      window.alert("success!");
    } catch (error) {
      window.alert("got error but handled");
    }
  }, []);

  const triggerNotHandled = useCallback(async (code) => {
    try {
      await axios.get(`https://mock.httpstatus.io/${code}`);
    } catch (error) {
      // eslint-disable-next-line no-undef
      wogaa_snowplow('trackError', { error });
    }
  }, []);

  return (
    <div className='em-content'>
      <h1>API Call Simulator</h1>
      <h2>Success call</h2>
      <div className='em-button-container'>
        {
          successCodes.map((code) => (
            <button className="em-example-button" key={code} onClick={() => triggerHandled(code)}>
              trigger {code}
            </button>
          ))
        }
      </div>
      <h2>Error is handled</h2>
      <div className='em-button-container'>
        {
          errorCodes.map((code) => (
            <button className="em-example-button" key={code} onClick={() => triggerHandled(code)}>
              trigger {code}
            </button>
          ))
        }
      </div>
      <h2>Error is not handled</h2>
      <div className='em-button-container'>
        {
          errorCodes.map((code) => (
            <button className="em-example-button" key={code} onClick={() => triggerNotHandled(code)}>
              trigger {code}
            </button>
          ))
        }
      </div>
      <h1>Page Redirection</h1>
      <button className="em-example-button" onClick={() => navigate('/non-existent-path')}>
        go 404
      </button>
    </div>
  );
};
